const imageExtensions = [
    ".gif",
    ".jpg",
    ".jpeg",
    ".png",
    ".bmp",
    ".jpe",
    ".tif",
    ".tiff",
]
export const isImage = (path: string): boolean => {
    return imageExtensions.some((ext) => path.toLowerCase().endsWith(ext))
}

// https://stackoverflow.com/questions/15900485/correct-way-to-convert-size-in-bytes-to-kb-mb-gb-in-javascript
export function formatFileSize(bytes: number): string {
    if (bytes === 0) {
        return "0 Bytes"
    }

    const k = 1024
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i]
}
